import styled, { css } from 'astroturf/react';
import Button from 'src/components/Button';
import SelectBox from '../SelectBox';
import Svg from '../Svg/Svg';

const Column = styled('div')`
  font-size: var(--ph-text-sm);
  color: var(--black);
  position: relative;
  border-right: solid 2px var(--ph-gray-500);
  border-bottom: solid 2px var(--ph-gray-500);

  &:nth-child(1) {
    width: 40px;
    border-left: solid 2px var(--ph-gray-500);
  }

  &:nth-child(2) {
    width: 150px;
  }

  &:nth-child(3) {
    width: 150px;
  }

  &:nth-child(4) {
    width: 80px;
  }

  &:nth-child(5) {
    width: 160px;
  }

  &:nth-child(6) {
    width: 160px;
  }

  &:nth-child(1n + 7) {
    width: 40px;
  }

  &.header {
    border-top: solid 2px var(--ph-gray-500);
    border-bottom: solid 2px var(--ph-gray-500);
    background-color: var(--ph-gray-100);
    text-align: center;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    word-break: break-all;
  }

  &.content {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const ColumnSummary = styled('div')`
  font-size: var(--ph-text-sm);
  color: var(--black);
  position: relative;
  border-right: solid 2px var(--ph-gray-500);
  border-bottom: solid 2px var(--ph-gray-500);

  &:nth-child(1) {
    width: 150px;
    font-weight: bold;
    border-left: solid 2px var(--ph-gray-500);
  }

  &:nth-child(2) {
    width: 75px;
  }

  &:nth-child(3) {
    width: 75px;
  }

  &:nth-child(4) {
    width: 80px;
  }

  &:nth-child(5) {
    width: 80px;
  }

  &:nth-child(6) {
    width: 100px;
  }

  &.header {
    border-top: solid 2px var(--ph-gray-500);
    border-bottom: solid 2px var(--ph-gray-500);
    background-color: var(--ph-gray-100);
  }

  &.col2 {
    width: 150px;
  }

  &.content {
    text-align: center;
  }

  &.level {
    font-weight: bold;
    text-shadow: 1px 1px 2px black, 1px -1px 2px black, -1px 1px 2px black,
      -1px -1px 2px black;
    letter-spacing: 2px;
  }
`;

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 2% 1%;
  overflow: auto;
  row-gap: 4rem;

  &.last {
    padding-bottom: 150px;
  }
`;

const TableRow = styled('div')`
  min-height: 20px;
  display: -webkit-box;

  &.withColumns {
    border-top: 0;
  }

  &.noborder {
    border: 0;
  }

  &.label {
    background-color: var(--ph-light-blue-500);
    color: var(--white);
    border-radius: var(--ph-border-radius-sm);
    padding: 3px;
    font-size: var(--ph-text-xs);
  }

  span {
    max-width: 75%;
    text-overflow: ellipsis;
    display: inline-block;
  }
  .react-select__option {
    display: flex !important;
  }
`;

const Row = styled('div')`
  display: flex;
  flex-direction: row;
  page-break-inside: avoid;
  break-inside: avoid;

  & > div {
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.54;
    letter-spacing: normal;
    color: var(--black);
    padding: 5px 10px;
  }

  &.Title > div {
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: left;
    border-bottom: 2px solid var(--ph-gray-25);
  }

  &.section > div {
    background-color: var(--black);
    border: 0;
    margin-top: 20px;
  }
`;

const Cell = styled('div')`
  flex: 1;

  &:nth-child(1) {
    width: 150px;
    padding-right: 20px;
  }

  &:nth-child(2) {
    width: 150px;
    padding-right: 20px;
  }

  &:only-child {
    width: max-content;
  }

  &.label {
    color: var(--ph-gray-500);
  }

  &.flex-none {
    flex: 0;
  }

  &.flex-center {
    display: flex;
    align-items: center;
  }
`;

const Label = styled('div')`
  font-size: var(--ph-text-sm);
  color: var(--ph-gray-500);

  &.Title {
    font-size: var(--ph-text-md);
    font-weight: Bold;
  }

  &.space-below {
    margin-bottom: 20px;
  }
  &.center {
    display: flex;
    justify-content: center;
  }
`;

const StatusSelectBox = styled(SelectBox)`
  margin: 4px 0 !important;
  label {
    margin: 4px 0 !important;
  }
`;

const LinkButton = styled(Button)`
  border-bottom: 0 !important;
`;

const ConfirmButton = styled(Button)`
  &.disabled {
    background-color: var(--ph-gray-50) !important;
    color: var(--ph-gray-300);
    cursor: not-allowed;

    &:focus {
      box-shadow: none !important;
    }
  }
`;

const ButtonIcon = styled(Svg)`
  width: 14px;
  margin-right: 2px;
`;

const PopupRow = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;

  &.space-above {
    margin-top: 20px;
  }
`;

const DownloadBtn = styled(Button)`
  transition: var(--ph-button-transition);
  font-family: var(--ph-font-family-franklin-medium-regular);
  font-size: var(--ph-text-sm);
  color: var(--white);
  background-color: var(--ph-orange-500);
  border-radius: var(--ph-border-radius-sm);
  display: inline-flex;
  appearance: none;
  align-items: center;
  justify-content: center;
  user-select: none;
  touch-action: manipulation;
  text-transform: none;
  position: relative;
  white-space: nowrap;
  vertical-align: middle;
  line-height: 1.2;
  outline: none;
  height: 32px;
  border: 0;
  cursor: pointer;

  &:hover {
    background-color: var(--ph-orange-700);
  }

  &:active {
    background-color: var(--ph-orange-900);
  }

  &:focus {
    box-shadow: var(--ph-box-shadow-focus);
  }
  
  div[id*="icon-tail-spin"] {
    margin-right: 0px;
  }
`;

const DownloadIcon = styled(Svg)`
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translate(0%, -50%);
  width: 12px;
`;

export default {
  Column,
  ColumnSummary,
  TableRow,
  Container,
  Row,
  Cell,
  Label,
  StatusSelectBox,
  LinkButton,
  ConfirmButton,
  PopupRow,
  ButtonIcon,
  DownloadBtn,
  DownloadIcon
};
